import { Params } from "@angular/router";

export enum EBackgroundOperationStatus {
  InProgress = "InProgress",
  Completed = "Completed",
  Failed = "Failed",
}

export interface IStartCoiGenerationParams {
  readonly policyId: string;
  readonly policyNumber: string | null;
  readonly openRoute: readonly string[];
  readonly openQueryParams?: Params;
}

export interface IBackgroundOperation extends IStartCoiGenerationParams {
  readonly id: string;
  readonly status: EBackgroundOperationStatus;
}
